import React, { useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchAllRegions,
  fetchRegionalCongressman,
} from "services/services.congressman";
import { CONGRESS_OPTIONS, REGION_PARTYLIST_ID } from "utility/constants";
import CustomSelect from "components/customs/dropdown";
import { customCongressStyles } from "constants/style";
import styled from "styled-components";
import DistrictCard from "./DistrictCard";
import { setSelectedCongress } from "../../../redux/reducers/congress";
import { getDistrictRepresentatives, formatPartylistData } from "../utility";

const HeaderSection = styled.div`
  margin-bottom: 1.5rem;
`;

const Wrapper = styled.div`
  margin-top: 50px;
`;

const RegionText = styled.span`
  --bs-text-opacity: 1;
  color: #6c757d;
`;

const SelectorContainer = styled.div`
  margin-top: 1rem;
  width: 25%;
`;

const RowSection = styled(Row)`
  margin-top: 3rem;
`;

const RepresentativeContainer = styled(Col)`
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
`;

const DistrictText = styled.h5`
  font-weight: bold;
`;

const RepresentativeWrapper = styled(Row)`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 3rem;
`;

const Main = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [regionDetails, setRegionDetails] = useState([]);
  const [regionList, setRegionList] = useState([]);
  const { id } = useParams();

  const selectedCongress = useSelector(
    (state) => state.congress.selectedCongress
  );
  const dispatch = useDispatch();

  const fetchData = () => {
    fetchRegionalCongressman({
      params: id,
      selectedCongress,
      callback: (data) => {
        if (data?.length !== 0) {
          // if region is partylist
          if (Number(id) === REGION_PARTYLIST_ID) {
            const result = formatPartylistData(data, id);
            setFilteredData(result);
          } else {
            const result = getDistrictRepresentatives(data, id);
            setFilteredData(result);
          }
        }
      },
    });
  };

  const fetchRegions = () => {
    fetchAllRegions({
      callback: (response) => {
        setRegionList(response);
      },
    });
  };

  useEffect(() => {
    if (regionList?.length !== 0) {
      regionList?.forEach((op, index) => {
        if (op?.id === Number(id)) {
          setRegionDetails(regionList[index]);
        }
      });
    }
  }, [regionList]);

  useEffect(() => {
    fetchRegions();
  }, []);

  useEffect(() => {
    if (selectedCongress) {
      fetchData();
    }
  }, [selectedCongress]);

  return (
    <Wrapper>
      <Col className="container">
        <HeaderSection>
          <h3>{"District Representatives"}</h3>

          {/* eslint-disable-next-line max-len */}
          <RegionText>{`${regionDetails?.acronym} - ${regionDetails?.name}`}</RegionText>
          <SelectorContainer>
            <CustomSelect
              placeholder="Congress"
              styles={customCongressStyles}
              options={CONGRESS_OPTIONS}
              value={CONGRESS_OPTIONS.find(
                (opt) => opt.value === selectedCongress
              )}
              onChange={(option) => {
                dispatch(setSelectedCongress(option.value));
              }}
            />
          </SelectorContainer>
        </HeaderSection>

        <RowSection>
          {Number(id) === REGION_PARTYLIST_ID
            ? filteredData?.length !== 0 &&
              filteredData?.map((datum) => {
                return (
                  <RepresentativeContainer
                    key={datum?.id}
                    xs="auto"
                  >
                    <DistrictCard {...datum} />
                  </RepresentativeContainer>
                );
              })
            : filteredData?.length !== 0 &&
              filteredData?.map((datum) => {
                return (
                  <RepresentativeWrapper key={datum?.id}>
                    <DistrictText>{datum[0]}</DistrictText>
                    {datum[1]?.map((list) => {
                      return (
                        <RepresentativeContainer
                          key={list?.id}
                          xs="auto"
                        >
                          <DistrictCard {...list} />
                        </RepresentativeContainer>
                      );
                    })}
                  </RepresentativeWrapper>
                );
              })}
        </RowSection>
      </Col>
    </Wrapper>
  );
};

export default Main;
